
import { AlertTriangle, Shield } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Separator } from "@/components/ui/separator";

const ProfilePrivacyInfo = () => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium">Privacy Information</h3>
      
      <Alert className="bg-slate-50 border-slate-200">
        <Shield className="h-4 w-4 text-slate-800" />
        <AlertTitle>How we use your information</AlertTitle>
        <AlertDescription>
          <p className="mb-2">Your profile information is used in the following ways:</p>
          <ul className="list-disc pl-5 space-y-1 text-sm">
            <li>Your name and contact details can be included at the bottom of refund request emails</li>
            <li>Your location (country, region) helps provide relevant legal context for your refund requests</li>
            <li>We do not share your information with third parties except as necessary to provide our services</li>
          </ul>
        </AlertDescription>
      </Alert>
      
      <Separator />
      
      <Alert variant="destructive" className="bg-red-50">
        <AlertTriangle className="h-4 w-4" />
        <AlertTitle>Important Information</AlertTitle>
        <AlertDescription className="text-sm">
          All information included in your profile may be shared with merchants as part of your refund request process.
          Only include information you're comfortable sharing in business communications.
        </AlertDescription>
      </Alert>
    </div>
  );
};

export default ProfilePrivacyInfo;
